import { Video, VideoOff } from "lucide-react";
import { useShallow } from "zustand/react/shallow";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { getCurrentParticipant } from "../api/get-current-participant";
import { useIsModerator } from "../api/is-moderator";
import {
  useMuteParticipantVideo,
  useUnmuteParticipantVideo,
} from "../api/mute-participant-video";

export function ToggleAllCamera() {
  const isModerator = useIsModerator();
  const sessionId = useVidyoStore((state) => state.sessionId);
  const isAllMuted = useVidyoStore(
    useShallow((state) =>
      state.participants.participants.every(
        (participant) =>
          participant.isCurrentUser || !participant.isVideoEnabled,
      ),
    ),
  );
  const currentParticipant = getCurrentParticipant();

  const {
    mutate: disableParticipantsVideo,
    isPending: isMutatingDisableParticipantsVideo,
  } = useMuteParticipantVideo();
  const {
    mutate: enableParticipantsVideo,
    isPending: isMutatingEnableParticipantsVideo,
  } = useUnmuteParticipantVideo();

  const isLoading =
    isMutatingDisableParticipantsVideo || isMutatingEnableParticipantsVideo;

  const handleDisableAllParticipants = () => {
    disableParticipantsVideo({
      sessionId: sessionId,
      body: {
        isApplyingActionToAll: true,
        participantId: currentParticipant?.participantId,
      },
    });
  };

  const handleEnableAllParticipants = () => {
    enableParticipantsVideo({
      sessionId: sessionId,
      body: {
        isApplyingActionToAll: true,
        participantId: currentParticipant?.participantId,
      },
    });
  };

  const handleButtonClick = isAllMuted
    ? handleEnableAllParticipants
    : handleDisableAllParticipants;

  if (!isModerator) {
    return null;
  }

  return (
    <>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleButtonClick}
            disabled={isLoading}
            isLoading={isLoading}
          >
            <VideoOff className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Disable all cameras</p>
        </TooltipContent>
      </Tooltip>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleButtonClick}
            disabled={isLoading}
            isLoading={isLoading}
          >
            <Video className="size-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Enable all cameras</p>
        </TooltipContent>
      </Tooltip>
    </>
  );
}
